import { assoc, dissoc, map as mapRamda, mergeDeepLeft, pathOr } from 'ramda'
import { node } from 'prop-types'
import React, { useContext, useState } from 'react'
/* eslint import/no-webpack-loader-syntax: off */
/* eslint-disable-next-line import/no-unresolved */
import maplibre from '!maplibre-gl'

import getMapLayers from './config/mapLayers'
import getMapLayersElastic from './config/mapLayersElastic'
import getMapSources from './config/mapSources'
import MapContext from './MapContext'

const MapProvider = ({ children }) => {
  const context = useContext(MapContext)
  const [maps, setMaps] = useState(context.maps)

  const addMap = (id, map) => {
    setMaps(assoc(id, map, maps))
  }

  const removeMap = id => {
    setMaps(dissoc(id, maps))
  }

  const getMap = id => pathOr(null, [id], maps)

  const createMap = options => {
    const map = new maplibre.Map(
      mergeDeepLeft(options, {
        style: {
          version: 8,
          sources: getMapSources(),
          layers: [...getMapLayersElastic(), ...getMapLayers()],
          glyphs: 'https://tiles.maps.elastic.co/fonts/{fontstack}/{range}.pbf',
          sprite: 'https://tiles.maps.elastic.co/styles/osm-bright/sprite',
        },
      }),
    )

    map.addControl(new maplibre.NavigationControl())

    return map
  }

  const mapUpdateContainer = (map, container) => {
    const oldContainer = map.getContainer()

    mapRamda(() => {
      container.appendChild(oldContainer.childNodes[0])
    }, oldContainer.childNodes)

    container.className = oldContainer.className // eslint-disable-line no-param-reassign
    map._container = container // eslint-disable-line no-param-reassign, no-underscore-dangle

    map.resize()
    if (map.isStyleLoaded()) {
      map.fire('load')
    } else {
      map.once('styledata', () => map.fire('load'))
    }

    return map
  }

  return (
    <MapContext.Provider
      value={{ maps, addMap, removeMap, getMap, createMap, mapUpdateContainer }}
    >
      {children}
    </MapContext.Provider>
  )
}

MapProvider.propTypes = {
  children: node,
}

MapProvider.defaultProps = {
  children: null,
}

export default MapProvider
